type WebComponentTag = keyof JSX.IntrinsicElements;

const asWebComponentTag = <T extends WebComponentTag>(tag: T): T => tag;

export const BdsIcon = asWebComponentTag('bds-icon');
export const BdsAvatar = asWebComponentTag('bds-avatar');
export const BdsSidebar = asWebComponentTag('bds-sidebar');
export const BdsThemeProvider = asWebComponentTag('bds-theme-provider');
export const BdsTypo = asWebComponentTag('bds-typo');
export const BdsIllustration = asWebComponentTag('bds-illustration');
export const BdsNavTree = asWebComponentTag('bds-nav-tree');
export const BdsGrid = asWebComponentTag('bds-grid');
export const BdsNavTreeItem = asWebComponentTag('bds-nav-tree-item');
export const BdsNavTreeGroup = asWebComponentTag('bds-nav-tree-group');
export const BdsButton = asWebComponentTag('bds-button');
export const BdsCard = asWebComponentTag('bds-card');
export const BdsCardHeader = asWebComponentTag('bds-card-header');
export const BdsCardBody = asWebComponentTag('bds-card-body');
export const BdsCardFooter = asWebComponentTag('bds-card-footer');
export const BdsChipTag = asWebComponentTag('bds-chip-tag');
export const BdsTooltip = asWebComponentTag('bds-tooltip');
export const BdsDivider = asWebComponentTag('bds-divider');
export const BdsChipClickable = asWebComponentTag('bds-chip-clickable');
export const BdsAccordion = asWebComponentTag('bds-accordion');
export const BdsAccordionHeader = asWebComponentTag('bds-accordion-header');
export const BdsAccordionBody = asWebComponentTag('bds-accordion-body');
export const BdsInput = asWebComponentTag('bds-input');
export const BdsRadio = asWebComponentTag('bds-radio');
export const BdsRadioGroup = asWebComponentTag('bds-radio-group');
export const BdsButtonGroup = asWebComponentTag('bds-button-group');
export const BdsAutocomplete = asWebComponentTag('bds-autocomplete');
export const BdsLoadingSpinner = asWebComponentTag('bds-loading-spinner');
export const BdsCheckbox = asWebComponentTag('bds-checkbox');
export const BdsSwitch = asWebComponentTag('bds-switch');
